import type { SVGProps } from "react";

/** Line-art “feedback edit” mark from Figma (node 4333:710 / feedBackIcon 4333:657). Uses `currentColor` so it matches button/link text. */
export default function FeedbackEditIcon(props: SVGProps<SVGSVGElement>) {
  const { width = 22, height = 22, ...rest } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.1528 17.1015C11.1527 17.0174 11.0846 16.9492 11.0005 16.9491C10.9375 16.9491 10.8831 16.9874 10.8599 17.0419L10.8481 17.1015C10.8481 17.1857 10.9162 17.2538 11.0005 17.2538L11.0601 17.2421C11.1146 17.2189 11.1528 17.1645 11.1528 17.1015Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M16.1737 19.5593C14.6643 20.4736 12.8936 21 11 21C5.47716 21 1 16.5228 1 11C1 5.47712 5.47716 1 11 1C16.5229 1 21 5.47712 21 11C21 13.0537 20.3668 14.9628 19.3051 16.5508"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1528 17.1015C11.1527 17.0174 11.0846 16.9492 11.0005 16.9491C10.9375 16.9491 10.8831 16.9874 10.8599 17.0419L10.8481 17.1015C10.8481 17.1857 10.9162 17.2538 11.0005 17.2538L11.0601 17.2421C11.1146 17.2189 11.1528 17.1645 11.1528 17.1015Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M7.31421 8.49954C7.31421 6.46382 8.96451 4.81352 11.0002 4.81352C13.0359 4.81352 14.6862 6.46382 14.6862 8.49954H14.6871C14.6874 10.0227 13.7641 11.3303 12.4467 11.8927C11.5631 12.2699 11.0002 13.1749 11.0002 14.1356"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
